import { createFileRoute, redirect } from "@tanstack/react-router";

import { DashboardLayout } from "@/components/layout/dashboard-layout";
import { RequireSession } from "@/hooks/shared/CheckAuth";
import { can } from "@/constants/permissions";
import {
  rememberReturnTo,
  resolveSession,
  SessionUnavailableError,
} from "@/hooks/shared/session";
import { lastSignedInSession } from "@/context/session-context";

export const Route = createFileRoute("/_main")({
  beforeLoad: async ({ location }) => {
    try {
      const session = await resolveSession();

      if (!session) {
        rememberReturnTo(location.pathname, location.searchStr);
        throw redirect({ to: "/login" });
      }

      if (!can(session.user.role, "console.access")) {
        throw redirect({ to: "/mobile-only" });
      }

      return { session };
    } catch (error) {
      if (error instanceof SessionUnavailableError && lastSignedInSession) {
        /* API blip with a cookie session we already held — keep the console up
           rather than bouncing to login. Subsequent reads will surface the outage. */
        if (!can(lastSignedInSession.user.role, "console.access")) {
          throw redirect({ to: "/mobile-only" });
        }
        return { session: lastSignedInSession };
      }
      throw error;
    }
  },
  component: MainLayout,
});

function MainLayout() {
  return (
    <RequireSession>
      <DashboardLayout />
    </RequireSession>
  );
}
